import { mutator } from 'satcheljs';
import { setScenarioCondensedViewCalendars } from '../actions/calendarActions';
import getCalendarPickerStore from '../selectors/getCalendarPickerStore';

mutator(setScenarioCondensedViewCalendars, actionMessage => {
    const pickerStore = getCalendarPickerStore(actionMessage.scenarioId);
    pickerStore.condensedViewCalendars.set(
        actionMessage.userIdentity,
        actionMessage.selectedCalendars.map(selectedCalendar => selectedCalendar.id.id)
    );
});
